import { Badge } from "./ui/badge";

const SEV_STYLES = {
  high: "severity-high",
  medium: "severity-medium",
  low: "severity-low",
};

const STAT_STYLES = {
  new: "status-new",
  under_review: "status-under_review",
  resolved: "status-resolved",
  ignored: "status-ignored",
  needs_manual_merge: "status-under_review",
  needs_ops_correction: "status-under_review",
  needs_automation_review: "status-under_review",
};

export function SeverityPill({ level }) {
  const cls = SEV_STYLES[level] || "severity-low";
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium ${cls}`} data-testid={`severity-pill-${level}`}>
      {level?.toUpperCase()}
    </span>
  );
}

export function StatusPill({ status }) {
  const cls = STAT_STYLES[status] || "status-new";
  const label = status?.replaceAll("_", " ");
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium capitalize ${cls}`} data-testid={`status-pill-${status}`}>
      {label}
    </span>
  );
}
